<template>
  <footer class="page-footer">
    <div class="footer-wrapper">
      <div class="page-footer__inner">
        <base-nav
            :title="$t('shared.new-cars')"
            :items="newCars"
            :title-link="`${getLinkPrefix}new-cars`"
            multi-column="2"
            class="page-footer__column"
        />
        <div class="page-footer__columns-wrapper">
          <div class="page-footer__column">
            <base-nav
                :title="$t('shared.hyundai-leasing')"
                :title-link="`${getLinkPrefix}fleet-vehicles`"
            />
            <base-nav :title="$t('shared.used-cars')" />
            <base-nav
                :title="$t('shared.charge-my-hyundai')"
                :title-link="`${getLinkPrefix}charge-myhyundai/Charge-myHyundai.html`"
            />
            <base-nav
              :title="$t('shared.owning')"
              :items="owning"
              :title-link="`${getLinkPrefix}owning`"
            />
          </div>
          <div class="page-footer__column page-footer__align-right">
            <base-nav
                :title="$t('shared.customer-service')"
                :items="customerService"
            ></base-nav>
          </div>
        </div>
      </div>
      <div class="page-footer__bottom-footer">
        <div class="page-footer__logo">
          <a :href="`${getLinkPrefix}home`">
            <img
                class="images__image"
                :src="logoImage"
                :alt="$t('image-slider.car-photo')"
            />
          </a>
        </div>
        <div class="page-footer__bottom-footer-content">
          <div class="page-footer__bottom-footer-links-wrapper">
            <base-nav
                v-for="bottomFooterLink in bottomFooterLinks"
                :key="bottomFooterLink.name"
                :title="bottomFooterLink.name"
                :title-link="`${getLinkPrefix}${bottomFooterLink.link}`"
                :has-no-margin="true"
                class="page-footer__bottom-footer-link"
            ></base-nav>
          </div>
          <div
              class="page-footer__copyright"
              v-html="$t('footer.copyrights')"
          ></div>
          <div class="page-footer__mobile-nav">
            <a
                v-for="footerMobile in footerMobileNav"
                :key="footerMobile.name"
                :href="footerMobile.link"
                class="page-footer__mobile-nav-button"
            >
              {{ footerMobile.name }}
            </a>
          </div>
        </div>
        <div class="page-footer__social-links">
          <a
              v-for="socialLink in socialLinks"
              :key="socialLink.link"
              :href="socialLink.link"
              class="page-footer__social-link"
          >
            <img :src="socialLink.image"/>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import BaseNav from "@/components/ui/BaseNav/BaseNav.vue";
import logoImage from "@/assets/images/footer-logo.png";
import {
  siteLink,
  newCars,
  owning,
  customerService,
  financeLink,
  bottomFooterLinks,
  socialLinks,
  footerMobileNav
} from "@/constants/links";

export default {
  name: "TheFooter",
  components: {
    BaseNav
  },
  computed: {
    getLinkPrefix() {
      return this.$store.state.isMobile ? siteLink.mobile : siteLink.desktop;
    },
    newCars() {
      return newCars;
    },
    owning() {
      return owning;
    },
    customerService() {
      return customerService;
    },
    logoImage() {
      return logoImage;
    },
    bottomFooterLinks() {
      return bottomFooterLinks;
    },
    socialLinks() {
      return socialLinks;
    },
    footerMobileNav() {
      return footerMobileNav;
    }
  }
};
</script>

<style scoped lang="scss">
.page-footer {
  background-color: $color-grey-800;
  padding: 20px 20px 15px;

  &__logo {
    &__img {
      height: 25px;
    }
  }

  &__inner {
    display: none;
  }

  &__bottom-footer {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }

  &__column {
    width: 100%;
  }

  &__columns-wrapper {
    width: 100%;
    display: flex;
  }

  &__align-right {
    display: flex;
    flex-direction: column;
  }

  &__bottom-footer-link {
    margin: 0;
    padding: 15px 20px;
  }

  &__bottom-footer-links-wrapper {
    display: flex;
    border-top: 1px solid $color-grey-700;
    margin-top: 20px;
    justify-content: center;
  }

  &__copyright {
    padding-left: 20px;
    padding-bottom: 15px;
    opacity: .5;
    color: $color-white;
    font-size: $font-size-s;
    text-align: center;
    display: none;
  }

  &__social-links {
    margin-left: auto;
    margin-right: auto;
    display: flex;
  }

  &__social-link {
    margin-left: 20px;
    margin-right: 20px;
  }

  &__mobile-nav {
    display: flex;
    justify-content: center;
  }

  &__mobile-nav-button {
    min-width: 120px;
    margin: 0 10px;
    padding: 10px;
    color: $color-white;
    text-align: center;
    cursor: pointer;
    transition: all .35s;

    &:hover {
      text-decoration: underline;
      opacity: .7;
    }
  }

  &__bottom-footer-content {
    width: 100%;
  }
}

@media screen and (min-width: $media-m) {
  .page-footer {
    padding: 45px 20px 15px;
  }

  .footer-wrapper {
    max-width: 1140px;
    margin: 0 auto;
  }

  .page-footer__logo {
    margin-right: 10px;
  }

  .page-footer__inner {
    width: 100%;
    flex-direction: row;
    display: flex;
  }

  .page-footer__column,
  .page-footer__columns-wrapper {
    width: 50%;
  }

  .page-footer__align-right {
    align-items: flex-end;
  }

  .page-footer__bottom-footer {
    flex-direction: row;
    border-top: 1px solid $color-grey-700;
    margin-top: 20px;
    padding-top: 15px;
    align-items: center;
  }

  .page-footer__bottom-footer-links-wrapper {
    border-top: none;
    margin: 0;
    justify-content: flex-start;
  }

  .page-footer__copyright {
    display: block;
    text-align: left;
  }

  .page-footer__mobile-nav {
    display: none;
  }

  .page-footer__social-links,
  .page-footer__social-link {
    margin-right: 0;
  }

  .page-footer__bottom-footer-content {
    width: auto;
  }
}

@media screen and (min-width: $media-l) {
  .page-footer__inner .legal {
    margin-top: 50px;
    padding: 50px 0;
  }
}

@media screen and (min-width: $media-xl) {
  .page-footer {
    padding-left: calc(100% / 12);
    padding-right: calc(100% / 12);
  }
}
</style>
